import { DimensionGroupingsGridView } from '~/components/attributes/dimension-groupings';
import { PageContainer } from '~/components/page-container';

export function DimensionGroupings() {
	return (
		<PageContainer>
			<DimensionGroupingsGridView />
		</PageContainer>
	);
}
